module.exports = __webpack_public_path__ + "img/productBgImg11.3a9afbbd.png";